import Column from "../../../Common/Column";
import List from "@mui/material/List";
import {ListItem, TextField, useTheme} from "@mui/material";
import React, {useEffect, useState} from "react";
import Fuse from "fuse.js";
import {categoryStore} from "../../../../Stores/CategoryStore";
import Typography from "@mui/material/Typography";
import Space from "../../../Common/Space";
import {useNavigate} from "react-router-dom";
import useSnackbar from "../../../Snackbar/SnackbarHook";
import {accountStore} from "../../../../Stores/AccountStore";
import {useMediaContext} from "../../../../MediaContext";

export const CategorySearch = () => {
    const theme = useTheme();
    const isTouchInput = useMediaContext().isTouchInput;
    const isMobileSize = useMediaContext().isMobileSize;
    const navigate = useNavigate();
    const snackbar = useSnackbar();

    const [searchTerm, setSearchTerm] = useState('');
    const [searchItems, setSearchItems] = useState();
    const [fuse, setFuse] = useState();

    const fuseOptions = {
        includeScore: true,
        keys: [
            'lvl1.name',
            'lvl2.name',
            'lvl3.name',
            'lvl4.name',
            'lvl5.name',
        ],
    };

    useEffect(() => {
        setFuse(new Fuse(categoryStore.categorySearchList, fuseOptions));
    }, []);

    useEffect(() => {
        if (fuse == null)
            return;

        const result = fuse.search(searchTerm);
        const filtered = result.map(({ item }) => item);
        setSearchItems(filtered);
    }, [searchTerm, fuse]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleItemClick = (index) => {
        const item = searchItems[index]
        const selectedIds = mapItemToIds(item);

        let tree = categoryStore.categoryTree;

        selectedIds?.forEach(id => {
            const category = tree.find(category => category.id === id);

            if (category.children.length > 0) {
                tree = category.children;
                return;
            }

            if (category.requiresMitid && !accountStore.user.mitIdValidated) {
                snackbar.handleOpen("Kategorien kræver MitID validering", "error");
                return;
            }

            navigate(`/opret-annonce/${category.id}`);
        });
    };

    const mapItemToIds = (category) => {
        const selectedIds = [];
        for (let i = 1; i <= category.lvls; i++) {
            selectedIds.push(category[`lvl${i}`].id);
        }
        return selectedIds;
    };

    const handleTouchStart = (e) => {
        e.currentTarget.classList.add("highlight");
    };

    const handleTouchEndOrCancel = (e) => {
        e.currentTarget.classList.remove("highlight");
    };

    return <Column>
        <Typography>
            Hvad vil du sælge?
        </Typography>
        <Space height="10px"/>
        <TextField
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="F.eks. 'Riffel' eller 'Hund'"
            sx={{
                "& .MuiInputBase-root": {
                    backgroundColor: "white",
                },
                maxWidth: isMobileSize ? "100%" : "20rem",
                marginBottom: "8px",
            }}
            fullWidth
        />
        <List>
            {searchItems?.slice(0, 9).map((item, index) => {
                const deepestLevel = item[`lvl${item.lvls}`].name;

                const parentLevels = Array.from({ length: item.lvls - 1 }, (_, i) => {
                    const level = item[`lvl${item.lvls - 1 - i}`].name;
                    return `› ${level}`;
                }).join(" ");

                return <ListItem
                    key={index}
                    onClick={() => handleItemClick(index)}
                    sx={{
                        paddingLeft: "5px",
                        width: "auto",
                        ...(isMobileSize && {
                            border: "1px solid black",
                            display: "block",
                            marginBottom: "7px",
                            borderRadius: "5px",
                            padding: "15px 20px",
                            borderColor: "lightgray",
                            maxWidth: "100%",
                        }),
                        cursor: 'pointer',
                        "&:hover": !isTouchInput && {
                            ...(isMobileSize
                                ? { backgroundColor: theme.palette.action.hover }
                                : { fontWeight: "bold" }),
                        },
                        "&.highlight": isTouchInput && isMobileSize && {
                            backgroundColor: theme.palette.action.hover,
                        },
                    }}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEndOrCancel}
                    onTouchCancel={handleTouchEndOrCancel}
                >
                    <span style={{marginRight: "5px"}}>
                        {deepestLevel}
                    </span>
                    <span style={{fontSize: 'smaller', color: 'grey'}}>
                        {parentLevels}
                    </span>
                </ListItem>
            })}
        </List>
    </Column>
}